import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Tagged, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  zone: Identifiable<Tagged<Zone>>;
  retrieveZone(request: Boundaries["retrieveZone"]["request"]): void;
}

function useZoneRetrieval(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isZoneRetrievalRequestPending),
    isRequestSuccess: useSelector(selector.isZoneRetrievalRequestSuccess),
    isRequestFailure: useSelector(selector.isZoneRetrievalRequestFailure),
    zone: useSelector(selector.getZone),
    retrieveZone: core.retrieveZone,
  };
}

export { useZoneRetrieval };
